var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.30323C0.5 5.51574 0.81283 4.7605 1.36967 4.20366C1.92651 3.64681 2.68175 3.33398 3.46924 3.33398H10.1995C10.987 3.33398 11.7423 3.64681 12.2991 4.20366C12.8559 4.7605 13.1688 5.51574 13.1688 6.30323V13.0335C13.1688 13.821 12.8559 14.5763 12.2991 15.1331C11.7423 15.6899 10.987 16.0028 10.1995 16.0028H3.46924C2.68175 16.0028 1.92651 15.6899 1.36967 15.1331C0.81283 14.5763 0.5 13.821 0.5 13.0335V6.30323ZM17.3273 14.96L13.9606 12.6352V6.69913L17.3273 4.37441C18.2458 3.73939 19.5 4.39816 19.5 5.5146V13.8206C19.5 14.937 18.2466 15.5942 17.3273 14.96Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.05ab7ccc5315ba9d8fa0eb3a6abb205d.svg";
export { ForwardRef as ReactComponent };